import { ReactElement, ReactNode, useState } from 'react';
import { Card } from 'semantic-ui-react';
import GridColumnInputWrapper from '@components/common/GridColumnInputWrapper';
import CommonTagsInputWrapper from '@components/common/CommonTagsInputWrapper';
import PersonPopup from '@components/Filtering/OverviewTable/InventorySimplifiedView/Components/PersonPopup';
import styles from './styles/Activity.module.scss';
import { personsActions } from '@behavior/persons';
import { ContactDTO } from '@behavior/inventories/dto/ContactDTO';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { PersonDTO } from '@behavior/inventories/dto/PersonDTO';

type Props = {
  contactList: ContactDTO[];
  setContactList?: (contactList: ContactDTO[]) => void;
  title: string;
  placeholder: string;
  disabled?: boolean;
  showPersonalData?: boolean;
  isNotMissingLmsCourses?: boolean;
  optionsContainer?: ReactNode;
};

const AddContactsList = ({
  contactList,
  setContactList,
  title,
  placeholder,
  disabled,
  showPersonalData,
  isNotMissingLmsCourses,
  optionsContainer,
}: Props) => {
  const [clearInputCounter, setClearInputCounter] = useState(0);

  const onContactSelect = (selectedOption: PersonDTO) => {
    const contactExists = contactList.some(contact => contact.person.id === selectedOption.id);

    if (!contactExists) {
      const newItem: ContactDTO = {
        id: null,
        person: selectedOption,
      };
      const updatedList = [...contactList, newItem];
      if (setContactList) {
        setContactList(updatedList);
      }
    }
    clearNewContact();
  };
  const clearNewContact = () => {
    setClearInputCounter(clearInputCounter + 1);
  };
  const onDeleteIcon = (contact: PersonDTO) => {
    const updatedContacts = contactList.filter(c => c.person.id !== contact.id);
    if (setContactList) {
      setContactList(updatedContacts);
    }
  };
  const renderSelectedContacts = () => {
    return (
      <div className={styles.flexContainer}>
        {contactList.map((contact, index) => (
          <div
            key={contact.person.id}
            className={disabled ? `${styles.disabledContactList}` : `${styles.exposedPersonnel}`}
          >
            <PersonPopup
              contact={contact.person}
              closeIcon={!disabled}
              onDelete={() => onDeleteIcon(contact.person)}
              showPersonalData={showPersonalData}
              showWarning={contact.person?.isMissingLmsCourses}
              role={contact.role}
            />
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className={styles.activityTextContainer}>
      <Card className={styles.cardText}>
        <div className={`${styles.basicDiv} ${styles.tableContainer}`}>
          <div className={styles.riskTextHeader}>{title}</div>

          <div className={styles.departmentContainer}>
            <GridColumnInputWrapper
              render={(props: any) => (
                <CommonTagsInputWrapper
                  name={'newPerson.person'}
                  dynamicSuggestionListAction={(v: any) =>
                    personsActions.getPersonAutocompleteListAction(v, isNotMissingLmsCourses)
                  }
                  matchProperty={'name'}
                  displayProps={'name'}
                  maxTags={1}
                  onlyUnique
                  clearInputCounter={clearInputCounter}
                  disabled={disabled}
                  placeholder={placeholder}
                  className={styles.contactInput}
                  onSelect={onContactSelect}
                />
              )}
            />
          </div>
          {contactList?.length > 0 && renderSelectedContacts()}
          {!disabled && optionsContainer && (
            <div className="contactListOptions">{optionsContainer}</div>
          )}
        </div>
      </Card>
    </div>
  );
};

AddContactsList.defaultProps = {
  isNotMissingLmsCourses: true,
};

const mapStateToProps = (state: any) => ({
  showPersonalData: state.dataPrivacy.showPersonalData,
});

export default compose(connect(mapStateToProps, null))(AddContactsList);
